{
  "version": 1,
  "asset_id": "f10ebd11-1f45-487c-ab93-e5022a10d3ad",
  "project_id": "9fb22223-732b-4b0d-9eac-b115ce8cfd9c",
  "url": "/__l5e/assets-v1/f10ebd11-1f45-487c-ab93-e5022a10d3ad/flashweb-logo.webp",
  "r2_key": "a/v1/9fb22223-732b-4b0d-9eac-b115ce8cfd9c/f10ebd11-1f45-487c-ab93-e5022a10d3ad/flashweb-logo.webp",
  "original_filename": "flashweb-logo.webp",
  "size": 8564,
  "content_type": "image/webp",
  "created_at": "2026-06-29T16:49:38Z"
}
